// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"1f60072f","459":"a7f1b1ad","490":"9941e2ec","733":"de4d4208","776":"67cd15e3","778":"cad4517a","788":"ea97b810","855":"9313ee47"}[chunkId] + ".chunk.css";
};